import { Plus } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  onCreate: () => void
  isCreating: boolean
}

/** Первая карточка сетки: «Создать курс». Размером и скруглением — как карточка курса;
 *  на телефоне — невысокая полоса-кнопка: во всю ширину плитка съедала полэкрана. */
export const CreateCourseCard = ({ onCreate, isCreating }: Props) => {
  const m = useMessages(messages)
  return (
    <button
      type="button"
      onClick={onCreate}
      disabled={isCreating}
      className="group flex h-16 w-full flex-row items-center justify-center gap-3 rounded-[20px] md:h-auto md:min-h-[240px] md:flex-col border-2 border-dashed border-foreground/15 text-base text-muted-foreground outline-none transition-colors hover:border-brand/50 hover:bg-brand/5 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-60"
    >
      <span className="flex size-9 items-center justify-center rounded-full bg-brand/15 text-brand transition-transform group-hover:scale-105 md:size-14">
        <Plus className="size-5 md:size-7" />
      </span>
      {isCreating ? m.creating : m.createCourse}
    </button>
  )
}
